import React from 'react';
import RegGate from '../components/RegGate';

// Renders the F&B Registration page design (self-contained HTML in /public/fnb.html).
// The form posts directly to /api/fnb/register via an injected script.
function FnbPageForm() {
  return (
    <iframe
      src="/fnb.html"
      title="F&B Registration — Talesverse"
      data-testid="fnb-frame"
      style={{ position: 'fixed', inset: 0, width: '100%', height: '100%', border: 'none', display: 'block' }}
    />
  );
}

export default function FnbPage() {
  return <RegGate kind="fnb"><FnbPageForm /></RegGate>;
}
